import { render } from "./print-order-report.vue?vue&type=template&id=b284f416"
import script from "./print-order-report.vue?vue&type=script&lang=js"
export * from "./print-order-report.vue?vue&type=script&lang=js"

import exportComponent from "C:\\source-ali\\Order-Management\\OrderManagement-Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__